import type { PopStoreSubscriptionLevel } from '@ps/models/lib/creator-subscription';

import type {
  CommitmentPeriod,
  SubscriptionInterval,
} from '../types/CheckoutType';
import { StoreScopedIntentBuilder } from './StoreScopedIntentBuilder';

/** Consumer → creator community membership subscription. */
export class CommunitySubscriptionIntentBuilder extends StoreScopedIntentBuilder {
  /** The membership tier (`subscriber` / `fan` / `vip`). */
  plan(plan: PopStoreSubscriptionLevel): this {
    this.root.param('plan', plan);
    return this;
  }

  interval(interval: SubscriptionInterval): this {
    this.root.param('interval', interval);
    return this;
  }

  /** Billing commitment — `'long'` only when the plan offers the discount. */
  commitment(period: CommitmentPeriod): this {
    this.root.param('commitment_period', period);
    return this;
  }

  /** Consent to personalized offers — required; carried into `createFollower`. */
  agreeToOffers(agree: boolean): this {
    this.root.param('agree_to_recv_personalized_offers', agree ? '1' : '0');
    return this;
  }

  /** Consent to share the phone number — required; carried into `createFollower`. */
  consentToSharePhone(consent: boolean): this {
    this.root.param('consent_to_share_phone_number', consent ? '1' : '0');
    return this;
  }
}
